import { IconButton, Text } from '@chakra-ui/react';
import { ReactComponent as CloseCircleIcon } from 'assets/icons/close_circle.svg';
import { ReactComponent as CSVIcon } from 'assets/icons/csv_icon.svg';
import { useTranslation } from 'react-i18next';

interface FileNameProps {
  name: string;
  onDelete?: () => void;
}

export const FileTag = ({ name, onDelete }: FileNameProps) => {
  const { t } = useTranslation('common_components', { useSuspense: false, keyPrefix: 'chat.promptInput' });

  return (
    <Text
      as='span'
      bg='dark-blue.50'
      textAlign='right'
      borderRadius='base'
      gap={1}
      display='inline-flex'
      alignItems='center'
      verticalAlign='bottom'
    >
      <CSVIcon style={{ display: 'inline-block', verticalAlign: 'bottom' }} />
      {name}
      {!!onDelete && (
        <IconButton
          variant={'ghost'}
          size={'sm'}
          onClick={onDelete}
          aria-label={t('deleteFile')}
          icon={<CloseCircleIcon />}
        />
      )}
    </Text>
  );
};
